import { createFileRoute } from '@tanstack/react-router';

import { scratchpadDetailSearchSchema } from '@apps/web/features/admin_agent_scratchpad/model/search_params';
import { ScratchpadNoteDetailPage } from '@apps/web/features/admin_agent_scratchpad/ui/note_detail_page';
import { ScratchpadNotesFrame } from '@apps/web/features/admin_agent_scratchpad/ui/notes_frame';

export const Route = createFileRoute('/_app/admin/agent/scratchpad/$note-id')({
    component: ScratchpadNoteDetailRoute,
    validateSearch: scratchpadDetailSearchSchema,
    head: () => ({
        meta: [{ title: 'Note | Internal Admin Agent' }],
    }),
});

function ScratchpadNoteDetailRoute() {
    const params = Route.useParams();
    const search = Route.useSearch();
    return (
        <ScratchpadNotesFrame>
            <ScratchpadNoteDetailPage
                noteId={params['note-id']}
                search={search}
            />
        </ScratchpadNotesFrame>
    );
}
